// extracted by mini-css-extract-plugin
export var container = "FoodMenuTemplate-module--container--10h3p";
export var body = "FoodMenuTemplate-module--body--3asGX";